// Habillage commun des barres supérieures — celle de l'application et celle de la vitrine.
//
// Partagé pour que les deux ne divergent pas : elles se suivent à une navigation d'écart, et
// un bouton de thème qui change de forme entre les deux se remarque aussitôt.

/** Bouton d'action rond de la zone de droite (thème, langue, cloche, sortie). */
export const ACTION =
  'grid size-10 place-items-center rounded-full bg-fill-subtle text-text-secondary transition-[background-color,color,transform] duration-200 hover:bg-border hover:text-text-primary active:scale-95 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-action';
